import { render, staticRenderFns } from "./address-list-dialog.vue?vue&type=template&id=a2f869fa&scoped=true"
import script from "./address-list-dialog.vue?vue&type=script&lang=js"
export * from "./address-list-dialog.vue?vue&type=script&lang=js"
import style0 from "./address-list-dialog.vue?vue&type=style&index=0&id=a2f869fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f869fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f869fa')) {
      api.createRecord('a2f869fa', component.options)
    } else {
      api.reload('a2f869fa', component.options)
    }
    module.hot.accept("./address-list-dialog.vue?vue&type=template&id=a2f869fa&scoped=true", function () {
      api.rerender('a2f869fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/address/address-list-dialog.vue"
export default component.exports